export default {
  "copy_max_tip": "The maximum number of table items has been reached and cannot be copied",
  "copy": "Copy",
  "add_item": "Add a new line",
  "confirm_delete": "Are you sure to delete?",
  "confirm": "Yes",
  "cancel": "No",
  "operate": "Operate",
  "delete": "Delete",
  "edit": "Edit",
  "img_src_error": "Image address error",
  "upload": "Upload",
  "upload_success": "upload success",
  "upload_fail": "upload failed",
  "uploaded_address": "Uploaded address",
  "test_src": "Test address",
  "schema_not_match": "Schema does not match the display component：",
  "item": "Item",
  "search": "Search",
  "reset": "Reset",
  "expand": "Expand",
  "fold": "Fold",
  "submit": "Submit",
  "moveDown": "Move Down",
  "moveUp": "Move Up"
};